export default __webpack_public_path__ + "static/media/setting_black.7439f1bb.svg";